import { render, staticRenderFns } from "./shopUnbindOwner.vue?vue&type=template&id=6ce7afdf&scoped=true"
import script from "./shopUnbindOwner.vue?vue&type=script&lang=js"
export * from "./shopUnbindOwner.vue?vue&type=script&lang=js"
import style0 from "./shopUnbindOwner.vue?vue&type=style&index=0&id=6ce7afdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7afdf",
  null
  
)

export default component.exports